import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'
import Subtitle from 'LuxKit/Typography/Subtitle'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalBody from 'LuxKit/Modal/ModalBody'

const StyledModalContent = styled(ModalContent)`
  min-height: ${rem(200)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${rem(20)};
`

const AnimationWrapper = styled.div`
  color: ${props => props.theme.palette.brand.primary.normal};
  width: ${rem(100)};
  max-width: 100%;
`

interface Props {
  isOpen?: boolean;
  message?: string;
  className?: string;
}

function ProcessingModal(props: React.PropsWithChildren<Props>) {
  const {
    isOpen,
    message,
    className,
  } = props

  return (
    <ModalBase isOpen={isOpen} className={className}>
      <ModalBody>
        <StyledModalContent>
          <AnimationWrapper>
            <LoadingAnimation />
          </AnimationWrapper>
          {message && <Subtitle variant="subtitle1" align="center">{message}</Subtitle>}
        </StyledModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default ProcessingModal
